import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "account-wrapper text-left" }
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = {
  key: 0,
  class: "column is-4 friControllerCol1"
}
const _hoisted_4 = {
  class: "account-box is-navigation p-0 mt-0",
  style: {"border":"none !important"}
}
const _hoisted_5 = { class: "account-menu me-5" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  "aria-hidden": "true",
  class: "lnil lnil-user-alt"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "end" }, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "fas fa-arrow-right"
  })
], -1)
const _hoisted_9 = {
  key: 1,
  class: "column is-8 ps-0",
  id: "friControllerCol2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ControllerDash = _resolveComponent("ControllerDash")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.menu, (section, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["account-menu-item cursor-pointer", _ctx.layout.section == index ? 'router-link-active router-link-exact-active' : '']),
                    key: index,
                    onClick: ($event: any) => (_ctx.toSection(index))
                  }, [
                    _hoisted_7,
                    _createElementVNode("span", null, [
                      _createElementVNode("i", {
                        class: _normalizeClass(section.icon+' fs-3 align-middle')
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(section.name), 1)
                    ]),
                    _hoisted_8
                  ], 10, _hoisted_6))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.layout.controllerId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_ctx.layout.section == 'dashboard')
              ? (_openBlock(), _createBlock(_component_ControllerDash, {
                  key: 0,
                  controllerId: _ctx.layout.controllerId,
                  isMobile: _ctx.isMobile
                }, null, 8, ["controllerId", "isMobile"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}